import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <p>
              Copyright © 2021 VVIP Mobile Coffee bar
                        support: <a href="https://github.com/codedbystuart/">Telcode</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
};

export default Footer;
